export default __webpack_public_path__ + "static/media/header-bg.e745a74b.png";